import { render, staticRenderFns } from "./LiveFlux.vue?vue&type=template&id=a817b12c&scoped=true"
import script from "./LiveFlux.vue?vue&type=script&lang=js"
export * from "./LiveFlux.vue?vue&type=script&lang=js"
import style0 from "./LiveFlux.vue?vue&type=style&index=0&id=a817b12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a817b12c",
  null
  
)

export default component.exports